document.addEventListener("DOMContentLoaded", function () {

  const dropdownAdress = document.querySelectorAll('.dropdown-address');

  dropdownAdress.forEach(dropdown => {
    dropdown.addEventListener('click', () => {

      if (dropdown.classList.contains('show')) {

        dropdown.classList.remove('show');
      } else {
        dropdown.classList.add('show');
        dropdownMenuAddress.addEventListener('mouseleave', () => {
          dropdown.classList.remove('show');
        })
      }

    });

    const dropdownParent = dropdown.parentElement;

    const dropdownMenuAddress = dropdownParent.querySelector('.dropdown-menu-address');
    const contactsItemTitle = dropdownParent.querySelector('.contacts-item__title span');
    const contactsItemText = dropdownParent.querySelector('.contacts-item__text');

    const dropdownItems = dropdownMenuAddress.querySelectorAll('ul > li');

    dropdownItems.forEach(item => {
        item.addEventListener('click', () => {
            contactsItemTitle.innerHTML = item.querySelector('.name').innerHTML;
            contactsItemText.innerHTML = item.querySelector('.address').innerHTML;

            dropdownItems.forEach(el => {
                el.classList.remove('sel');
            })

            item.classList.add('sel');
        })

    })

  });

});
